import React, { Component } from 'react';

class PotentialUser extends Component {
    render() {
        let className = "potential-member ";
        if (this.props.isSelected) {
            className += "selected";
        }
        return (
            <div
              onClick={this.props.onClick}
              className={className}>
              <div className="user-name">
                {this.props.userName}
              </div>
              <div className="user-id">
                {this.props.userId}
              </div>
            </div>
        );
    }
}

export default PotentialUser;
